import React, { Fragment, useContext } from "react";
import {
  Grid,
  Divider,
  Typography,
  FormControlLabel,
  TextField,
  Checkbox,
  List,
  ListItemText,
} from "@material-ui/core";
import WallpaperRoundedIcon from "@material-ui/icons/WallpaperRounded";

// Contexts
import OrderContext from "../../../../../../context/orders/v1/OrdersContext";

const LineItems = (props) => {
  const { classes, unfulfilledItems, products, getImage } = props;

  const { modalValues, modalErrors, setValues } = useContext(OrderContext);

  const handleChange = (e) => {
    const id = e.target.id;

    let new_values = Object.assign({}, modalValues);

    if (id === "line_items") {
      new_values.select_items[parseInt(e.target.name)] = e.target.checked;
    } else if (id === "quantity") {
      new_values.line_items.map((each) => {
        if (each.id === parseInt(e.target.name)) {
          if (e.target.value > 0 && e.target.value <= each.maxQty) {
            each.quantity = parseInt(e.target.value);
          }
        }
      });
    }

    setValues(new_values);
  };

  return (
    <Fragment>
      {" "}
      {modalErrors.line_items && (
        <List dense={true} className={classes.errorMessages}>
          <ListItemText> {modalErrors.line_items} </ListItemText>{" "}
        </List>
      )}
      <Typography variant="body2" className={classes.title}>
        QUANTITY TO FULFILL{" "}
      </Typography>
      <Grid
        item
        xs={12}
        container
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        className={classes.headerBox}
      >
        <Grid item xs={8} container justifyContent="flex-start">
          & emsp; & emsp; Items{" "}
        </Grid>
        <Grid item xs={2} container justifyContent="center">
          Weight{" "}
        </Grid>
        <Grid item xs={2} container justifyContent="center">
          Quantity{" "}
        </Grid>{" "}
      </Grid>
      {Object.keys(modalValues).length > 0 &&
        unfulfilledItems.map((item, index) => {
          const image =
            products[item.product_id] &&
            getImage(item.variant_id, products[item.product_id]);

          let fulfill_qty = 0;
          modalValues.line_items.map((each) => {
            if (each.id === item.id) {
              fulfill_qty = each.quantity;
            }
          });

          return (
            <Fragment key={index}>
              <Divider className={classes.divider} orientation="horizontal" />
              <FormControlLabel
                className={classes.lineItemControl}
                control={
                  <Checkbox
                    color="primary"
                    id="line_items"
                    name={String(item.id)}
                    checked={
                      modalValues.select_items[item.id]
                        ? modalValues.select_items[item.id]
                        : false
                    }
                    onChange={handleChange}
                  />
                }
                label={
                  <Grid
                    item
                    xs={12}
                    container
                    direction="row"
                    alignItems="center"
                    justifyContent="space-between"
                    className={classes.lineItemBox}
                  >
                    <Grid
                      item
                      xs={2}
                      container
                      direction="column"
                      alignItems="center"
                      justifyContent="center"
                    >
                      {image ? (
                        <img className={classes.image} src={image} />
                      ) : (
                        <WallpaperRoundedIcon fontSize="large" />
                      )}{" "}
                    </Grid>
                    <Grid
                      item
                      xs={5}
                      container
                      direction="column"
                      alignItems="flex-start"
                      justifyContent="center"
                    >
                      <Grid item> {item.title} </Grid>{" "}
                      <Grid item> {item.variant_title} </Grid>{" "}
                      <Grid item> SKU: {item.sku} </Grid>{" "}
                    </Grid>
                    <Grid
                      item
                      xs={2}
                      container
                      direction="column"
                      alignItems="center"
                      justifyContent="center"
                    >
                      {item.grams.toFixed(1)}
                      kg{" "}
                    </Grid>
                    <Grid
                      item
                      xs={2}
                      container
                      direction="column"
                      alignItems="flex-end"
                      justifyContent="center"
                    >
                      <TextField
                        type="number"
                        variant="outlined"
                        size="small"
                        margin="dense"
                        id="quantity"
                        name={String(item.id)}
                        InputProps={{
                          inputProps: {
                            min: 1,
                            max: item.quantity,
                          },
                        }}
                        value={fulfill_qty}
                        onChange={handleChange}
                      />{" "}
                    </Grid>
                    <Grid item xs={1} container direction="column">
                      & ensp; of {item.quantity}{" "}
                    </Grid>{" "}
                  </Grid>
                }
              />{" "}
            </Fragment>
          );
        })}{" "}
    </Fragment>
  );
};

export default LineItems;
